import React from 'react';
import { Box, Typography } from '@mui/material';
import { CheckCircle2 } from 'lucide-react';

const EmptyState = () => (
  <Box 
    display="flex" 
    flexDirection="column" 
    alignItems="center" 
    justifyContent="center" 
    p={4}
    gap={2}
  >
    <CheckCircle2 size={48} className="text-gray-400" />
    <Typography variant="body1" color="text.secondary">
      No new notifications
    </Typography>
  </Box>
);

export default EmptyState;